import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import DocumentsList from '@/components/common/DocumentsList';
import LoadingPage from '@/components/common/LoadingPage';
import PropertiesList from '@/components/common/PropertiesList';
import SubPageHeader from '@/components/common/SubPageHeader';
import { toDateString } from '@/lib/utils/date';
import formatCurrency from '@/lib/utils/formatCurrency';

import useSelectedParty from '../analysis/hooks/useSelectedParty';

import useClaim from './queries/hooks/useClaim';

export default function Detail() {
  const { t } = useTranslation();
  const { id } = useParams<{ id?: string }>();

  const party = useSelectedParty();

  const { data: claim, isLoading } = useClaim(party?.id ?? '', id ?? '', {
    enabled: Boolean(party?.id) && Boolean(id),
  });

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader>{claim?.type_of_coverage}</SubPageHeader>

      {isLoading && <LoadingPage />}

      {!isLoading && claim && (
        <div className="flex flex-col gap-2 p-2">
          <PropertiesList
            items={[
              {
                label: t('CLAIMS_CLAIM_DATE'),
                value: toDateString(claim.claim_date),
              },
              {
                label: t('CLAIMS_POLICY_NR'),
                value: claim.anva_policy_nr,
                copy: true,
              },
              {
                label: t('CLAIMS_COVERAGE'),
                value: claim.type_of_coverage,
              },
              {
                label: t('CLAIMS_AMOUNT'),
                value: formatCurrency(claim.total_amount),
              },
              {
                label: t('CLAIMS_DEDUCTIBLE'),
                value: formatCurrency(claim.own_risk),
              },
            ]}
          />

          <DocumentsList documents={claim.documents} />
        </div>
      )}
    </div>
  );
}
